import { useState, useCallback } from "react";

export const useInlineNotice = () => {
  const [notice, setNotice] = useState(null); // { type: 'error' | 'success', message }

  const showError = useCallback(
    (message) => setNotice({ type: "error", message }),
    [],
  );
  const showSuccess = useCallback(
    (message) => setNotice({ type: "success", message }),
    [],
  );
  const clear = useCallback(() => setNotice(null), []);

  return { notice, showError, showSuccess, clear };
};
